<template>
  <div id="wrap">
    <BaseHeader/>
    
    <Main v-if="$route.name =='main'" />
    <Aicc v-if="$route.name =='aicc'" />
    <Contact v-if="$route.name =='contact'" />
    <ConversationalAi v-if="$route.name =='conversationalAi'"/>

    <BaseFooter/>
  </div>
</template>

<script>

import BaseHeader from  '@/components/BaseHeader'; 
import BaseFooter from  '@/components/BaseFooter'; 

import Main from '@/components/Main'
import Aicc from '@/components/Aicc'
import Contact from '@/components/Contact'
import ConversationalAi from '@/components/ConversationalAi'


export default {
  name: 'App', 
  components: {
    BaseHeader, 
    BaseFooter, 
    Main, 
    Aicc, 
    Contact, 
    ConversationalAi
  }, 
  watch: {
    
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue